<template>
  <v-container>
    <!-- Boodil Widget -->
    <boodil-widget :id="boodilId"></boodil-widget>

    <v-row class="pb-2">
      <v-col cols="12" md="6" sm="12">
        <v-card class="pa-5">
          <div class="text-h6 mb-4">Customer Details</div>

          <v-form ref="form" lazy-validation>
            <v-text-field
              v-model="data.firstName"
              label="First Name"
              disabled
              color="#2dc59a"
            ></v-text-field>
            <v-text-field
              v-model="data.surname"
              label="Surname"
              disabled
              color="#2dc59a"
            ></v-text-field>
            <v-select
              v-model="data.email"
              :items="emails"
              label="Email"
              color="#2dc59a"
            >
            </v-select>
            <v-text-field
              v-model="data.mobile"
              label="Mobile"
              disabled
              color="#2dc59a"
            ></v-text-field>
            <v-text-field
              v-model="data.address1"
              label="Address 1"
              disabled
              color="#2dc59a"
            ></v-text-field>
            <v-text-field
              v-model="data.city"
              label="City"
              disabled
              color="#2dc59a"
            ></v-text-field>
            <v-text-field
              v-model="data.postcode"
              label="Postcode"
              disabled
              color="#2dc59a"
            ></v-text-field>
            <v-text-field
              v-model="data.country"
              label="Country"
              disabled
              color="#2dc59a"
            ></v-text-field>
          </v-form>
        </v-card>
      </v-col>

      <v-spacer></v-spacer>

      <v-col cols="12" md="6" sm="12">
        <v-card class="pa-5">
          <v-row justify="center" no-gutters>
            <v-col cols="6" justify="center">
              <div class="text-h6">Basket (1 item)</div>
            </v-col>
            <v-col cols="6" align="right">
              <v-img
                src="@/assets/schemes.png"
                position="center center"
                width="161px"
                contain
              ></v-img>
            </v-col>
          </v-row>

          <v-divider class="mt-2 mb-4"></v-divider>
          <v-row>
            <v-col cols="3"
              ><v-img
                src="@/assets/ipad.png"
                position="center center"
                width="75"
                contain
              ></v-img
            ></v-col>
            <v-col cols="9">
              <div class="mb-2 text-subtitle-2">Apple iPad Pro 12.9"</div>
              <div class="text-subtitle-2">
                Quantity: 1
                <span class="font-weight-bold" style="float: right"
                  >{{ currency }}{{ amount }}</span
                >
              </div>
            </v-col>
          </v-row>
          <v-divider class="mt-3 mb-2"></v-divider>
          <div class="text-subtitle-2">
            Basket Total
            <span class="font-weight-bold" style="float: right"
              >{{ currency }}{{ amount }}</span
            >
          </div>

          <v-divider class="mt-2 mb-4"></v-divider>

          <v-row>
            <v-col cols="12">
              <v-btn
                color="#68dcbb"
                class="boodil-pay-enabled"
                tile
                light
                block
                large
                >Pay By Card
              </v-btn>

              <!-- Boodil -->
              <v-btn
                color="black"
                class="boodil-pay-enabled mt-3"
                tile
                dark
                block
                large
                @click="createTransaction()"
                ><v-img
                  src="@/assets/boodil-pay-by-bank.png"
                  max-width="210"
                  position="center center"
                  contain
                ></v-img>
              </v-btn>
              <!-- <v-btn-toggle  class="d-flex flex-row mt-3">
                <v-btn
                  color="black"
                  class="boodil-pay-enabled flex-grow-1"
                  tile
                  dark
                  height="44px"
                  @click="createTransaction()"
                  ><v-img
                    src="@/assets/boodil-pay-by-bank.png"
                    max-width="210"
                    position="center center"
                    contain
                  ></v-img
                >
              </v-btn>

                <v-btn
                  v-if="oneClickCheckout?.oneClickLogo"
                  @click="createTransaction(true)"
                  width="48px"
                >
                  <img :src="oneClickCheckout.oneClickLogo" :height="oneClickCheckout.oneClickLogoSquareTile ? '48px' : '36px'" />
                </v-btn>
              </v-btn-toggle> -->

              <!-- ApplePay -->
              <v-btn
                color="black"
                class="boodil-pay-enabled mt-3"
                tile
                dark
                block
                large
                ><v-img
                  src="@/assets/applepay.png"
                  max-width="60px"
                  position="center center"
                  contain
                ></v-img>
              </v-btn>

              <!-- GooglePay -->
              <!-- <v-btn
                  color="#ebebeb"
                  class="boodil-pay-enabled mt-3"
                  tile
                  dark
                  block
                  large
                  ><v-img
                    src="@/assets/google-pay.png"
                    max-width="60"
                    position="center center"
                    contain
                  ></v-img
                >
              </v-btn> -->

              <!-- Klarna -->
              <v-btn
                color="#ffb3c7"
                class="boodil-pay-enabled mt-3"
                tile
                dark
                block
                large
                ><v-img
                  src="@/assets/klarna.png"
                  max-width="80"
                  position="center center"
                  contain
                ></v-img>
              </v-btn>

              <!-- PayPal -->
              <v-btn
                color="#ffcc00"
                class="boodil-pay-enabled mt-3"
                tile
                dark
                block
                large
                ><v-img
                  src="@/assets/paypal.png"
                  max-width="100"
                  position="center center"
                  contain
                ></v-img>
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      data: {
        firstName: "John",
        surname: "Doe",
        email: "dally@boodil.com",
        mobile: "447712345678",
        address1: "20 Boodil Street",
        city: "Manchester",
        postcode: "M3 4EN",
        country: process.env?.VUE_APP_HOSTED_PAYMENT ? "DE" : "GB",
        redirectUrl: process.env.VUE_APP_REDIRECT_URL,
      },
      emails: [
        "dally@boodil.com",
        "harry@boodil.com",
        "sam@boodil.com",
        "shane@boodil.com",
      ],
      boodilId: null,
      oneClickCheckout: null,
      oneClickBoodilId: null,
      currency: process.env.VUE_APP_CURRENCY === "GBP" ? "£" : "€",
      amount: process.env.VUE_APP_AMOUNT,
    };
  },

  beforeMount() {
    var boodil = document.createElement("script");
    boodil.setAttribute("type", "text/javascript");

    if (process.env.VUE_APP_MODE == "development") {
      // boodil.setAttribute("src", `${process.env.VUE_APP_URL}/boodil-dev.js`);
      boodil.setAttribute("src", `https://widget.boodil.com/dev.js`);
    } else {
      let widgetSrc = process.env?.VUE_APP_WIDGET_URL?.length ? process.env.VUE_APP_WIDGET_URL : 'https://widget.boodil.com/dev.js';
      boodil.setAttribute("src", widgetSrc);
    }

    document.head.appendChild(boodil);

    // this.getPreviouslyUsedBankByEmail();
  },

  mounted() {
    window.addEventListener("message", (e) => {
      if (e.data.event == "closed") {
        console.log(e.data);
      }
    });
  },

  methods: {
    createTransaction(oneClick = false) {
      this.$axios({
        method: "post",
        url: "create-transaction",
        data: {
          merchantUuid: process.env.VUE_APP_BOODIL_MERCHANT_UUID,
          reference: "Test Boodil",
          cart: [
            {
              sku: "12345",
              itemName: "Apple iPad Pro 12.9",
              quantity: "1",
              itemPrice: process.env.VUE_APP_AMOUNT,
              currency: process.env.VUE_APP_CURRENCY,
              shipping: "Royal Mail 1st Class",
            },
          ],
          amount: process.env.VUE_APP_AMOUNT,
          currency: process.env.VUE_APP_CURRENCY,
          email: this.data.email,
          mobile: this.data.mobile,
          firstName: this.data.firstName,
          surname: this.data.surname,
          address1: this.data.address1,
          city: this.data.city,
          postcode: this.data.postcode,
          country: this.data.country,
          customerId: 275,
          redirectUrl: process.env.VUE_APP_REDIRECT_URL,
          hostedPayment: process.env?.VUE_APP_HOSTED_PAYMENT,
        },
      })
        .then((res) => {
          if (!oneClick) {
            if (!process.env?.VUE_APP_HOSTED_PAYMENT) {
              this.boodilId = res.data.uuid;
            } else {
              console.log(res);
              window.location.href = res.data.hostedUrl;
            }
          } else {
            this.oneClickBoodilId = res.data.uuid;
            this.createOneClickPaymentAuth();
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getPreviouslyUsedBankByEmail() {
      this.$axios({
        method: "post",
        url: "previous-bank",
        data: {
          email: this.data.email,
        },
      })
        .then((res) => {
          this.oneClickCheckout = res.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    createOneClickPaymentAuth() {
      this.$axios({
        method: "post",
        url: "one-click-payment-auth",
        config: { headers: { "Content-Type": "application/json" } },
        data: {
          uuid: this.oneClickBoodilId,
          bankId: this.oneClickCheckout.bankId,
        },
      })
        .then((res) => {
          window.location.href = res.data.authUrl;
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
};
</script>

<style>
.boodil-pay-enabled {
  background-color: #000000;
}

.v-btn:before {
  opacity: 0 !important;
}

.v-ripple__container {
  opacity: 0 !important;
}
</style>